<!--互动游戏弹层-->
<template>
  <!--活动-->
  <div
    id="layerDealerAct"
    class="dlrLayer-iframe"
    :class="visible ? '' : 'fn-hide'"
    style="z-index: 1000"
  >
    <iframe
      ref="dealerAct"
      v-if="visible && url"
      frameborder="0"
      scrolling="no"
      width="100%"
      height="100%"
      border="0"
      :src="url"
    ></iframe>
  </div>
</template>
<script>
import dealerActService from '../../services/dealerAct.service';
import { mapGetters } from 'vuex';
export default {
  props: {
    activityId: {
      type: Number,
      required: true
    },
    activityType: {
      type: Number,
      required: true
    },
    salesId: {
      type: [Number, String],
      required: true
    }
  },
  data () {
    return {
      visible: true,
      url: ''
    };
  },
  mounted () {
    this.url = this.dealerActUrl();
  },
  computed: {
    ...mapGetters({
      phoneCallStatus: 'phoneCall/phoneCallStatus',
      vrSalesInfo: 'sales/vrSalesInfo'
    })
  },
  methods: {
    dealerActUrl () {
      let salesId = 0;
      let channelId = '';
      let channelType = 0;
      let eid = ''; // VR带看通话中的互动游戏线索eid：2022010601
      if (this.vrSalesInfo.salesId) {
        channelId = this.vrSalesInfo.channelId;
        salesId = this.vrSalesInfo.salesId;
        eid = '2|1211004|897|18491|204969|304069';
        channelType = 0;
      } else {
        channelId = '';
        salesId = Number(this.salesId);
        eid = dealerActService.getActClickEidName(this.activityType);
      }
      const queryParams = this.$queryParams;
      const pvareaid = queryParams.pvAreaId;
      return dealerActService.buildActUrl(pvareaid, this.activityId, this.activityType, salesId, channelId, channelType, eid);
    }
  }
};
</script>
